/*
by zhou 2016/10/19
 */
"use strict";
angular.module('newWindowStatusManageModule', [])
    .controller('newWindowStatusManageCtrl', ['$scope', "$modalInstance", "Params",
        function($scope, $modalInstance, Params) {
            initStatus();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status.windows = angular.copy(Params);
                $scope.title = Params.STATUSID === 0 ? "新建状态" : "修改状态";
                $scope.data.leixingJson = [
                    { name: "只在修改状态页面显示", value: 1 },
                    { name: "只在工作流中显示", value: 2 },
                    { name: "都显示", value: 3 },
                    { name: "都不显示", value: 0 }
                ];
            }
            /**
             * [selected 选择类型]
             * @return {[type]} [description]
             */
            $scope.selected = function(item) {
                $scope.status.windows.STYPE = item.value;
            };
            /**
             * [cancel description:取消]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description:确定]
             */
            $scope.confirm = function() {
                $modalInstance.close($scope.status.windows);
            };
        }
    ]);
